import { PropAsset } from './PropAsset';

// Bush - Çalı
// TODO: Replace with SVG asset
export class Bush extends PropAsset {
  readonly id = 'bush';
  readonly width = 32;
  readonly height = 26;
  readonly walkable = true;  // Can walk through bushes
  readonly collisionRadius = 0;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 10 * s, 5 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Bush color based on variant
    const colors = ['#2d5a2d', '#4a6a2d', '#2d4a3d']; // Green, yellow-green, dark green
    ctx.fillStyle = colors[variant || 0] || colors[0];

    // Main bush body
    ctx.beginPath();
    ctx.arc(cx, cy - 10 * s, 10 * s, 0, Math.PI * 2);
    ctx.fill();

    // Left bump
    ctx.beginPath();
    ctx.arc(cx - 7 * s, cy - 8 * s, 7 * s, 0, Math.PI * 2);
    ctx.fill();

    // Right bump
    ctx.beginPath();
    ctx.arc(cx + 7 * s, cy - 8 * s, 7 * s, 0, Math.PI * 2);
    ctx.fill();

    // Berries (variant 1)
    if (variant === 1) {
      ctx.fillStyle = '#cc3333';
      ctx.beginPath();
      ctx.arc(cx - 3 * s, cy - 12 * s, 2 * s, 0, Math.PI * 2);
      ctx.arc(cx + 4 * s, cy - 10 * s, 2 * s, 0, Math.PI * 2);
      ctx.arc(cx + 1 * s, cy - 8 * s, 2 * s, 0, Math.PI * 2);
      ctx.fill();
    }
  }
}
